export const anim = [
    {
        title: 'Porsche',
        image: './vid/img/car.jpg',
        source: './vid/porsche.mp4',
        id: 0,
    },
    {
        title: 'Crime / Suspense',
        image: './vid/img/crimeSuspense.jpg',
        source: './vid/crimeSuspense.mp4',
        id: 1,
    },
    {
        title: 'Beauty and the Beast',
        image: './vid/img/beautyBeast.jpg',
        source: './vid/beautyBeast.mp4',
        id: 2,
    },
    {
        title: 'Football',
        image: './vid/img/football.jpg',
        source: './vid/football.mp4',
        id: 3,
    },
    {
        title: 'BreakOut',
        image: './vid/img/breakOut.jpg',
        source: './vid/breakout.mp4',
        id: 4,
    },
    {
        title: 'KMIR - Palm Springs',
        image: './vid/img/kmir.jpg',
        source: './vid/kmir.mp4',
        id: 5,
    },
    {
        title: 'Megabucks',
        image: './vid/img/megabucks.jpg',
        source: './vid/megabucks.mp4',
        id: 6,
    },
    {
        title: 'Monopoly',
        image: './vid/img/monopoly.jpg',
        source: './vid/monopoly.mp4',
        id: 7,
    },
    {
        title: 'Wheel of Fortune',
        image: './vid/img/wheelOfFortune.jpg',
        source: './vid/wheelOfFortune.mp4',
        id: 8,
    },
    {
        title: 'On the Level',
        image: './vid/img/level.jpg',
        source: './vid/level.mp4',
        id: 9,
    },
    {
        title: 'Penguin Animation',
        image: './vid/img/penguin.jpg',
        source: './vid/penguin.mp4',
        id: 10,
    },
   
];